function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ");

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M503.8,923.1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M676.4,462.7l8.5,3.3L508,924.7l-8.5-3.3L676.4,462.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M985.4,74.6l1.4,9L501.2,160l-1.4-9L985.4,74.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M500.9,195.3l245.3,19.3l-0.7,9.1l-245.3-19.3L500.9,195.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M984.9,74.6l2.2,8.9L501.6,204.3l-2.2-8.9L984.9,74.6L984.9,74.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M741.7,217.3l8.3,3.9l-103.9,223l-8.3-3.9L741.7,217.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M983.7,75.2l4.6,7.9L748.1,223.2l-4.6-7.9L983.7,75.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M644.2,438.3l38.7,22.1l-4.5,8l-38.7-22.1L644.2,438.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.7,76l6.6,6.3L645.2,445.4l-6.6-6.3L982.7,76z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982,76.8l8,4.5l-482.3,844l-8-4.5L982,76.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M982.5,76.3l7.2,5.7L684.3,467.3l-7.2-5.7L982.5,76.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M500.1,195.3l0.8,9.1L255.8,226l-0.8-9.1L500.1,195.3L500.1,195.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M505,155.4l0.1,44.5l-9.2,0l-0.1-44.5L505,155.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15,79l486.6,116.5l-2.1,8.9L12.9,87.9L15,79z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.6,78.9l486.5,72l-1.3,9.1L13.3,88L14.6,78.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M365.1,440.9l141.2,201.5l-7.5,5.3L357.6,446.1L365.1,440.9L365.1,440.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M359,439.5l4.6,7.9l-38.4,22.5l-4.6-7.9L359,439.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M365.8,442.2l142.4,479.6l-8.8,2.6L357,444.8L365.8,442.2L365.8,442.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M327.2,464.3L508,921.5l-8.5,3.4L318.7,467.7L327.2,464.3L327.2,464.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.5,80.6l309,382.5l-7.1,5.8L10.4,86.3L17.5,80.6L17.5,80.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M259.6,219.4l105.9,222.1l-8.3,3.9L251.3,223.4L259.6,219.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.2,80.3l347.4,360.1l-6.6,6.4L10.7,86.6L17.2,80.3L17.2,80.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.2,79.5l241.5,138l-4.5,8L11.7,87.4L16.2,79.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M507.1,645l1.3,278.1l-9.2,0l-1.3-278.1L507.1,645z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M638.1,439.7l7.5,5.2L506.3,647.7l-7.5-5.2L638.1,439.7L638.1,439.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M637.5,441l8.8,2.5L508.2,924.4l-8.8-2.5L637.5,441L637.5,441z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.8,98l234.8,403.1l-7.9,4.6L19.9,102.6L27.8,98z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M262.6,501.1l245.2,419.7l-7.9,4.6L254.6,505.8L262.6,501.1L262.6,501.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.9,81.1L27.8,98l-7.9,4.6L10,85.7L17.9,81.1L17.9,81.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M500,76.4l0,9.2L14,88l0-9.2L500,76.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M986,74.5l0,9.2l-486,1.9l0-9.2L986,74.5z"
}));

const SvgTriangle = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  x: "0px",
  y: "0px",
  viewBox: "0 0 1000 1000",
  enableBackground: "new 0 0 1000 1000",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTriangle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/triangle.84e31767.svg";
export { ForwardRef as ReactComponent };